export default __webpack_public_path__ + "static/media/stats-background.d728adf3.svg";